module.exports = __webpack_public_path__ + "img/pass3.25d266fb.png";